import { render, staticRenderFns } from "./PreparoManutencao.vue?vue&type=template&id=304ed700&"
import script from "./PreparoManutencao.vue?vue&type=script&lang=js&"
export * from "./PreparoManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports